module.exports = __webpack_public_path__ + "img/login-img-1.77121153.svg";